__turbopack_context__.v({
  "footer": "FdX9sq_footer",
  "highlight": "FdX9sq_highlight",
  "overlayPanel": "FdX9sq_overlayPanel",
  "overlayPanels": "FdX9sq_overlayPanels",
  "pointer": "FdX9sq_pointer",
  "pointerShape": "FdX9sq_pointerShape",
  "popover": "FdX9sq_popover",
  "popoverBody": "FdX9sq_popoverBody",
  "popoverCard": "FdX9sq_popoverCard",
  "popoverHeader": "FdX9sq_popoverHeader",
  "popoverTitle": "FdX9sq_popoverTitle",
  "progress": "FdX9sq_progress",
  "root": "FdX9sq_root",
  "welcome": "FdX9sq_welcome",
  "welcomeBody": "FdX9sq_welcomeBody",
  "welcomeCard": "FdX9sq_welcomeCard",
  "welcomeFooter": "FdX9sq_welcomeFooter",
  "welcomeHeader": "FdX9sq_welcomeHeader",
  "welcomeTitle": "FdX9sq_welcomeTitle",
});
